import {BRANDS, LOGIN_CASES} from 'const'
import {getDefaultConfig, getFavicon, getFooterLogosByBrandList, getHeaderLogo} from '../commonHelper'
import config from 'config'
import {FOOTER_LOGO_TYPES} from 'const/logos'

const REGULAR_FONT = "'Ballinger Regular', Helvetica, Arial, sans-serif"
const BOLD_FONT = "'Ballinger Bold', Helvetica, Arial, sans-serif"
const MEDIUM_FONT = "'Ballinger Medium', Helvetica, Arial, sans-serif"
const COLORS = {
  error: '#E74E4B',
  success: '#64DDB9',
  warning: '#FFAC5A',
  info: '#3B72FF',
  aargauerZeitung: '#003478',
  cmMediaBlackSchwarz200: '#18191B',
  cmMediaBlackSilbergrau100: '#ECEEF1',
  cmMediaGreyBetongrau200: '#888B95',
  cmMediaBlueAzurblau100: '#3B72FF',
  cmMediaBlueAzurblau100Opacity60: '#87A8FD',
  cmMediaBlueAzurblau10: '#EBF1FF',
  ultraLight4: '#F7F7F7',
}
const BRAND_URL = 'https://www.aargauerzeitung.ch/'
const otherBrandsLogos = getFooterLogosByBrandList([
  BRANDS.aargauerzeitung,
  BRANDS.tagesanzeiger,
  BRANDS.twentymin,
  BRANDS.blick,
])

export default {
  brand: {
    url: BRAND_URL,
    name: BRANDS.aargauerzeitung,
    favicon: getFavicon(BRANDS.aargauerzeitung),
    fontColor: COLORS.ultraLight4,
    support: 'https://abo.aargauerzeitung.ch/kontakt/',
  },
  config: {
    ...getDefaultConfig(),
    useCircularSocialLogin: true,
    onePager: ({loginCase}) => [LOGIN_CASES.EMAIL_ONLY, LOGIN_CASES.DEFAULT].includes(loginCase),
  },
  otherBrandsLogos,
  fontConfig: {custom: {urls: [`${config.url}/fonts/aargauerzeitung/index.css`]}},
  separator: {
    background: COLORS.cmMediaBlueAzurblau10,
    fontSize: '16px',
    height: '1px',
    lineHeight: '25px',
    transform: 'none',
    lineMarginTop: '0',
    margin: '48px 0 36px 0',
    portraitMargin: '48px 0 36px 0',
    landscapeMargin: '48px 0 36px 0',
    family: BOLD_FONT,
    fontWeight: 700,
  },
  shell: {
    header: {
      color: '#FFF',
      backgroundColor: COLORS.aargauerZeitung,
      height: {
        default: '80px',
        onScroll: '56px',
        withEmail: '102px',
      },
      poweredLogo: {
        src: 'logo-onelog-poweredby-white.png',
      },
      logo: {
        height: {
          default: '36px',
          small: '36px',
          onScroll: '36px',
        },
        src: {
          default: 'brands/aargauerzeitung/logo-portrait.svg',
          small: getHeaderLogo(BRANDS.aargauerzeitung),
          onScroll: getHeaderLogo(BRANDS.aargauerzeitung),
        },
      },
      languageSwitcher: {
        color: '#FFF',
        activeColor: COLORS.aargauerZeitung,
        backgroundColor: '#FFFFFF',
        menu: {
          fontSize: '16px',
          lineHeight: '22px',
          color: '#18191b',
          hoverBackgroundColor: '#CFD3E3',
        },
      },
      menu: {
        default: {
          color: '#FFF',
          fontSize: '20px',
        },
        active: {
          color: '#FFFFFF',
          backgroundColor: COLORS.aargauerZeitung,
          hoverBackgroundColor: '#87a8fd',
          selectedBackgroundColor: '#3b72ff',
          separatorColor: '#2C3B47',
        },
      },
    },
    footer: {
      tenants: {
        logoColor: FOOTER_LOGO_TYPES.black,
        color: COLORS.cmMediaBlackSchwarz200,
        hoverColor: COLORS.cmMediaBlueAzurblau100,
        backgroundColor: '#FFF',
        fontSize: '12px',
        lineHeight: '26px',
        topSeparatorColor: COLORS.cmMediaBlueAzurblau10,
        separatorColor: COLORS.cmMediaBlueAzurblau10,
      },
      copyright: {
        color: '#888b95',
        hoverColor: '#888b95',
        backgroundColor: '#FFF',
        fontSize: '14px',
        lineHeight: '20px',
        separatorColor: COLORS.cmMediaBlueAzurblau10,
      },
    },
  },
  ringierBanner: {
    backgroundColor: COLORS.cmMediaBlackSilbergrau100,
    borderRadius: '4px',
    fontSize: '16px',
    lineHeight: '21px',
    linkFontSize: '12px',
    titleFontSize: '16px',
    landscape: {
      fontSize: '16px',
      titleFontSize: '16px',
    },
    titleFontWeight: '700',
    titleFontFamily: BOLD_FONT,
    onelogTitle: {
      fontSize: '12px',
      fontWeight: '500',
      lineHeight: '12px',
      fontFamily: MEDIUM_FONT,
      margin: '0 0 20px 0',
    },
    onelogSection: {
      padding: '40px 0 0 0',
      borderTop: `1px solid ${COLORS.cmMediaGreyBetongrau200}`,
    },
    onelogLogo: {
      src: '/assets/logo-onelog-black.svg',
      width: '94px',
      height: '20px',
    },
    benefitsIcon: `${config.url}/assets/brands/aargauerzeitung/icon-check-banner.svg`,
    padding: '20px',
    iconWidth: '24px',
    iconHeight: '24px',
  },
  font: {
    family: REGULAR_FONT,
    fontWeight: '400',
    boldFamily: BOLD_FONT,
    boldFontWeight: '700',
    size: '16px',
    height: '24px',
    mobile: {
      size: '16px',
      height: '24px',
    },
    portrait: {
      size: '16px',
      height: '24px',
    },
    color: {
      dark: COLORS.cmMediaBlackSchwarz200,
      light: '#FFFFFF',
    },
  },
  logisterSection: {
    registerMarginTop: '20px',
    registerWeight: 400,
    registerSize: '12px',
    noteColor: COLORS.cmMediaGreyBetongrau200,
    noteLineHeight: '21px',
    noteFontSize: {
      default: '16px',
      portrait: '16px',
    },
    subtitle: {
      lineHeight: '25px',
      margin: '-12px 0 12px',
      fontSize: {
        default: '16px',
        portrait: '16px',
      },
      link: {
        color: COLORS.cmMediaBlackSchwarz200,
      },
    },
    title: {
      textChangeBreakpoint: 'mobile',
      fontSize: {
        smallMobile: '28px',
        mobile: '28px',
        portrait: '32px',
        landscape: '32px',
        desktop: '32px',
      },
      lineHeight: {
        smallMobile: '35px',
        mobile: '35px',
        portrait: '40px',
        landscape: '40px',
        desktop: '40px',
      },
    },
  },
  buttons: {
    height: '56px',
    primary: {
      border: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
      color: '#FFFFFF',
      background: COLORS.cmMediaBlueAzurblau100,
      hoverBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100Opacity60}`,
      hoverBackground: COLORS.cmMediaBlueAzurblau100Opacity60,
      focusBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100Opacity60}`,
      focusBackground: COLORS.cmMediaBlueAzurblau100Opacity60,
      activeBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
      activeBackground: COLORS.cmMediaBlueAzurblau100,
      isAnimated: true,
      textStyles: {
        family: MEDIUM_FONT,
        size: '16px',
        weight: 500,
      },
    },
    secondary: {
      border: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
      color: COLORS.cmMediaBlueAzurblau100,
      background: '#FFFFFF',
      hoverColor: COLORS.cmMediaBlueAzurblau100Opacity60,
      hoverBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100Opacity60}`,
      hoverBackground: '#FFFFFF',
      focusColor: COLORS.cmMediaBlueAzurblau100Opacity60,
      focusBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100Opacity60}`,
      focusBackground: '#FFFFFF',
      activeBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
      activeColor: COLORS.cmMediaBlueAzurblau100,
      activeBackground: '#FFFFFF',
      textStyles: {
        size: '16px',
        family: MEDIUM_FONT,
        weight: 500,
      },
      dotsColor: COLORS.cmMediaBlueAzurblau100,
    },
    disabled: {
      border: `1px solid ${COLORS.cmMediaBlackSilbergrau100}`,
      color: COLORS.cmMediaGreyBetongrau200,
      background: '#FFFFFF',
      hoverBorder: `1px solid ${COLORS.cmMediaBlackSilbergrau100}`,
      hoverBackground: '#FFFFFF',
      activeBorder: `1px solid ${COLORS.cmMediaBlackSilbergrau100}`,
      activeBackground: '#FFFFFF',
    },
    touchId: {
      border: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
      color: '#FFFFFF',
      background: COLORS.cmMediaBlueAzurblau100,
      hoverBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100Opacity60}`,
      hoverBackground: COLORS.cmMediaBlueAzurblau100Opacity60,
      focusBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100Opacity60}`,
      focusBackground: COLORS.cmMediaBlueAzurblau100Opacity60,
      activeBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
      activeBackground: COLORS.cmMediaBlueAzurblau100,
      isAnimated: true,
      full: true,
      icon: 'icon-touchid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      textStyles: {
        size: '16px',
        family: MEDIUM_FONT,
      },
    },
    faceId: {
      border: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
      color: '#FFFFFF',
      background: COLORS.cmMediaBlueAzurblau100,
      hoverBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100Opacity60}`,
      hoverBackground: COLORS.cmMediaBlueAzurblau100Opacity60,
      focusBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100Opacity60}`,
      focusBackground: COLORS.cmMediaBlueAzurblau100Opacity60,
      activeBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
      activeBackground: COLORS.cmMediaBlueAzurblau100,
      isAnimated: true,
      full: true,
      icon: 'icon-faceid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      textStyles: {
        size: '16px',
        family: MEDIUM_FONT,
      },
    },
    anyId: {
      border: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
      color: '#FFFFFF',
      background: COLORS.cmMediaBlueAzurblau100,
      hoverBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100Opacity60}`,
      hoverBackground: COLORS.cmMediaBlueAzurblau100Opacity60,
      focusBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100Opacity60}`,
      focusBackground: COLORS.cmMediaBlueAzurblau100Opacity60,
      activeBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
      activeBackground: COLORS.cmMediaBlueAzurblau100,
      isAnimated: true,
      full: true,
      icon: 'icon-touchid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      textStyles: {
        size: '16px',
        family: MEDIUM_FONT,
      },
    },
    icon: {
      height: '24px',
      width: '24px',
    },
    text: {
      family: REGULAR_FONT,
      boldFamily: MEDIUM_FONT,
      color: COLORS.cmMediaBlackSchwarz200,
      size: '16px',
    },
    border: {
      radius: '4px',
    },
    linkOnSecondLine: true,
    dotsColor: '#FFFFFF',
  },
  title: {
    family: BOLD_FONT,
    size: '32px',
    height: '40px',
    margin: '0 0 24px 0',
    mobile: {
      size: '28px',
      height: '35px',
    },
    portrait: {
      size: '32px',
      height: '40px',
    },
    weight: '700',
  },
  input: {
    background: '#FFFFFF',
    color: COLORS.cmMediaBlackSchwarz200,
    errorBackground: '#FFFFFF',
    padding: '8px 12px',
    fontFamily: REGULAR_FONT,
    border: `1px solid ${COLORS.cmMediaGreyBetongrau200}`,
    errorBorder: `1px solid ${COLORS.error}`,
    hoverBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
    focusBorder: `1px solid ${COLORS.cmMediaGreyBetongrau200}`,
    borderRadius: '4px',
    height: '56px',
    fontSize: '16px',
    email: {
      color: COLORS.cmMediaGreyBetongrau200,
      backgroundColor: '#FFFFFF',
      border: `1px solid ${COLORS.cmMediaBlackSilbergrau100}`,
      borderRadius: '4px',
      button: {
        height: '40px',
        right: '12px',
        backgroundColor: '#FFFFFF',
        width: '70px',
        color: COLORS.cmMediaBlueAzurblau100,
        fontFamily: MEDIUM_FONT,
        fontSize: '14px',
        textDecoration: 'none',
        border: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
        borderRight: `1px solid ${COLORS.cmMediaBlueAzurblau100}`,
        borderRadius: '4px',
        hoverColor: COLORS.cmMediaBlueAzurblau100Opacity60,
        hoverBorder: `1px solid ${COLORS.cmMediaBlueAzurblau100Opacity60}`,
        hoverBorderRight: `1px solid ${COLORS.cmMediaBlueAzurblau100Opacity60}`,
      },
    },
    password: {
      color: COLORS.cmMediaBlackSchwarz200,
      hoverColor: COLORS.cmMediaBlueAzurblau100Opacity60,
      size: '12px',
      height: '12px',
      top: '21px',
    },
    loading: {
      top: '7px',
    },
    placeholder: {
      color: COLORS.cmMediaGreyBetongrau200,
      fontSize: '16px',
      lineHeight: '18px',
    },
  },
  edging: {
    borderRadius: '4px',
    backgroundColor: COLORS.cmMediaBlackSilbergrau100,
  },
  field: {
    label: {
      errorColor: COLORS.error,
      fontSize: '16px',
      family: REGULAR_FONT,
      disabledColor: COLORS.cmMediaGreyBetongrau200,
      fontHeight: '20px',
      fontWeight: '400',
      bottomMargin: '12px',
    },
    error: {
      background: 'inherit',
      fontColor: COLORS.error,
      size: '12px',
      height: '16px',
      padding: '0',
      margin: '8px 0 0',
    },
    optional: {
      fontSize: '14px',
      color: COLORS.cmMediaGreyBetongrau200,
      family: REGULAR_FONT,
    },
    edging: {
      backgroundColor: COLORS.cmMediaBlackSilbergrau100,
    },
  },
  link: {
    default: COLORS.cmMediaBlueAzurblau100,
    hoverColor: COLORS.cmMediaBlueAzurblau100Opacity60,
    infoHoverColor: COLORS.cmMediaBlueAzurblau100Opacity60,
    secondary: COLORS.cmMediaBlackSchwarz200,
    secondaryHover: COLORS.cmMediaBlueAzurblau100Opacity60,
    isAgreementsLink: true,
    agreement: COLORS.cmMediaBlackSchwarz200,
    textDecorationHover: 'underline',
    align: 'left',
  },
  secondaryFont: {
    size: '12px',
    height: '16px',
    mobile: {
      size: '12px',
      height: '16px',
    },
    portrait: {
      size: '12px',
      height: '16px',
      backlink: '12px',
    },
  },
  note: {
    family: REGULAR_FONT,
    lightFamily: REGULAR_FONT,
    fontSize: '16px',
    fontWeight: '400',
    lightFontWeight: '400',
    termsText: {
      fontSize: '12px',
      lineHeight: '16px',
    },
    termsTitle: {
      fontFamily: REGULAR_FONT,
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '23px',
      margin: '0',
    },
  },
  notification: {
    family: '',
    success: COLORS.success,
    error: COLORS.error,
    pageError: COLORS.error,
    warning: COLORS.warning,
    info: COLORS.info,
    icon: {
      width: '24px',
      height: '24px',
      mobile: {
        width: '32px',
        height: '32px',
      },
    },
    pageMessage: {
      size: '16px',
      height: '23px',
      sizeMobile: '16px',
      heightMobile: '23px',
      colorFunc: () => '#FFFFFF',
    },
  },
  form: {
    border: '',
    background: COLORS.cmMediaBlackSilbergrau100,
    fieldBackground: '',
    padding: '0 0 24px 0',
    sectionViewBackground: COLORS.cmMediaBlackSilbergrau100,
    marginBottom: '0',
    loginSubmitMarginTop: 16,
    note: {
      fontSize: '16px',
    },
  },
  logisterForm: {
    border: '',
    background: '',
    padding: '28px 0 0 0',
    submitButton: 'primary',
    submitButtonMargin: '36px 0 0 0',
    forgetLinkFloat: 'right',
  },
  loginForm: {
    submitButtonMargin: 36,
    title: {
      margin: '0 0 48px',
    },
    forgetLink: {
      wrapper: {
        defaultMarginBottom: '20px',
        errorMarginBottom: '22px',
        marginTop: '-26px',
      },
      link: {
        fontSize: '12px',
        marginTop: '6px',
        color: COLORS.cmMediaBlackSchwarz200,
      },
    },
  },
  registerPage: {
    backLinkMargin: {
      default: '0 0 24px',
      portrait: '0 0 24px',
    },
    titleMargin: {
      default: '0 0 24px',
      portrait: '0 0 24px',
    },
    submitButtonMarginTop: 36,
    subtitle: {
      fontFamily: BOLD_FONT,
      fontSize: '20px',
      lineHeight: '35px',
      margin: '0 0 48px',
      fontWeight: '700',
      color: COLORS.cmMediaBlackSchwarz200,
    },
  },
  resetPasswordPage: {
    subtitle: {
      fontSize: '16px',
      lineHeight: '23px',
      margin: '0 0 48px 0',
    },
  },
  emailVerifyPage: {
    noteMarginTop: '36px',
    linkMarginBottom: '10px',
    subtitleFontSize: '20px',
    note: {
      fontFamily: BOLD_FONT,
    },
    link: {
      color: COLORS.cmMediaBlueAzurblau100,
      fontSize: '16px',
    },
    subtitle: {
      fontFamily: BOLD_FONT,
    },
    message: {
      margin: 0,
    },
  },
  textarea: {
    height: '96px',
  },
  checkbox: {
    icon: {
      height: '20px',
      width: '20px',
      top: '0px',
      right: '12px',
      image: 'brands/aargauerzeitung/form/checkbox.svg',
      checkedImage: 'brands/aargauerzeitung/form/checkbox-checked.svg',
      hoverImage: 'brands/aargauerzeitung/form/checkbox-hover.svg',
      errorImage: 'brands/aargauerzeitung/form/checkbox-error.svg',
      disabledImage: 'brands/aargauerzeitung/form/checkbox-disabled.svg',
    },
    errorMargin: '',
    padding: '16px 20px',
    labelFontHeight: '24px',
    group: {
      label: {
        marginBottom: '12px',
        padding: '0',
        backgroundColor: '',
      },
      marginBottom: '20px',
      padding: '0 20px',
      backgroundColor: COLORS.cmMediaBlackSilbergrau100,
      fontWeight: '400',
      family: REGULAR_FONT,
      fontSize: '16px',
      note: {
        fontWeight: '400',
        fontSize: '16px',
        marginLeft: '32px',
      },
    },
    errorPadding: '4px 20px 0',
  },
  select: {
    fontFamily: REGULAR_FONT,
    icon: {
      width: '16px',
      height: '16px',
      image: 'brands/aargauerzeitung/icon-arrow-down.svg',
      focusImage: 'brands/aargauerzeitung/icon-arrow-down-active.svg',
      alt_image: 'brands/aargauerzeitung/icon-arrow-down.svg',
    },
    menu: {
      border: `1px solid ${COLORS.cmMediaGreyBetongrau200}`,
      isCheckIconVisible: false,
      checkIcon: 'NRJ-check-form-grey.svg',
      option: {
        fontFamily: REGULAR_FONT,
        padding: '4px 20px',
        focusBorder: '0',
        focusBackground: '#FFFFFF',
        focusColor: COLORS.cmMediaBlackSchwarz200,
        selectedFontFamily: BOLD_FONT,
      },
      placeholder: {
        color: COLORS.cmMediaGreyBetongrau200,
      },
      singleValue: {
        color: COLORS.cmMediaBlackSchwarz200,
      },
    },
    dropdownIndicator: {
      padding: '0',
    },
  },
  radio: {
    icon: {
      width: '20px',
      height: '20px',
      image: 'brands/aargauerzeitung/form/radio.svg',
      checkedImage: 'brands/aargauerzeitung/form/radio-active.svg',
      hoverImage: 'brands/aargauerzeitung/form/radio-hover.svg',
      errorImage: 'brands/aargauerzeitung/form/radio-error.svg',
      disabledImage: 'brands/aargauerzeitung/form/radio-disabled.svg',
    },
    errorMargin: '8px 0 0',
    labelFontHeight: '28px',
    labelMarginBottom: '12px',
    fontSize: '14px',
    fontFamily: REGULAR_FONT,
    fontWeight: 400,
  },
  errorPage: {
    font: {
      height: '16px',
      portrait: {
        height: '23px',
      },
    },
  },
  inputNote: {size: '12px', height: '16px', marginTop: '8px'},
  tab: {
    fontSize: '16px',
    desktop: {focusBorder: 'solid 4px #222222', bottomMargin: '-4px', height: '80px'},
    mobile: {icon: {border: 'solid 2px #222222', width: '14px', height: '14px', color: COLORS.cmMediaBlackSchwarz200}},
  },
  consent: {
    subtitle: {
      marginBottom: '12px',
      fontFamily: BOLD_FONT,
      fontSize: '20px',
    },
    checkbox: {
      marginBottom: '20px',
      paddingBottom: '',
    },
    agreements: {
      color: COLORS.cmMediaBlackSchwarz200,
    },
  },
  mobileNumber: {
    label: {
      marginBottom: '20px',
    },
    subtitle: {
      marginTop: '8px',
      color: COLORS.cmMediaBlackSchwarz200,
    },
    select: {
      padding: '8px 0px 8px 12px',
      backgroundColor: '#FFFFFF',
      borderRight: `1px solid ${COLORS.cmMediaGreyBetongrau200}`,
      hoverBorderRight: `1px solid ${COLORS.cmMediaGreyBetongrau200}`,
      focusBorderRight: `1px solid ${COLORS.cmMediaGreyBetongrau200}`,
      errorBorderRight: `1px solid ${COLORS.cmMediaGreyBetongrau200}`,
    },
    selectIcon: {
      padding: '0px 12px',
    },
    input: {
      backgroundColor: '#FFFFFF',
      errorBackgroundColor: '#FFFFFF',
      padding: '8px 12px',
    },
    code: {
      letterSpacing: '7px',
      paddingLeft: {
        normal: 'calc(50% - 50px)',
        error: 'calc(50% - 51px)',
      },
      underline: {
        left: 'calc(50% - 20px)',
        top: 'calc(50% - 7px)',
      },
    },
    questionLabel: {
      family: REGULAR_FONT,
      color: COLORS.cmMediaBlackSchwarz200,
    },
    link: {
      fontSize: '14px',
      lineHeight: '20px',
      fontFamily: REGULAR_FONT,
    },
    verifiedLabel: {
      color: COLORS.cmMediaBlackSchwarz200,
    },
    container: {
      marginBottom: '15px',
    },
  },
  address: {
    padding: '20px 20px 0px 20px',
    inputBackgroundColor: '#FFFFFF',
    formFieldMarginBottom: '',
    checkboxPadding: '0px 0px 20px 0px',
    link: {
      fontSize: '14px',
      lineHeight: '20px',
    },
    control: {
      fontSize: '16px',
      fontFamily: REGULAR_FONT,
      lineHeight: '24px',
    },
  },
  mfa: {
    inputPadding: '12px',
    subtitleFontSize: '16px',
    textFontSize: '16px',
    title: {
      margin: '0 0 48px',
    },
    link: {
      color: COLORS.cmMediaBlueAzurblau100,
      hoverColor: COLORS.cmMediaBlueAzurblau100Opacity60,
      margin: '0 0 12px',
      fontFamily: MEDIUM_FONT,
    },
  },
  webauthn: {
    dropdown: {
      color: COLORS.cmMediaBlueAzurblau100,
      hoverColor: COLORS.cmMediaBlueAzurblau100Opacity60,
      fontSize: '16px',
    },
    logisterForm: {
      marginBottom: '16px',
    },
    setup: {
      title: {
        margin: '0 0 12px',
      },
      description: {
        margin: '0 0 12px',
      },
      text: {
        margin: '0 0 16px',
      },
    },
  },
  emailVerifiedPage: {
    subtitle: {
      fontFamily: BOLD_FONT,
      fontSize: '20px',
      margin: '0 0 36px 0',
      color: COLORS.cmMediaBlackSchwarz200,
    },
  },
  languageSwitcher: {
    menuColor: COLORS.ultraLight4,
    menuIcon: 'OL-icon-arrow-down-white.svg',
    profileMenuIcon: 'OL-icon-arrow-down-white.svg',
    profileMenuColor: COLORS.ultraLight4,
  },
}
